import { render, staticRenderFns } from "./OnboardingWizard3Page.vue?vue&type=template&id=4c880435&scoped=true&"
import script from "./OnboardingWizard3Page.vue?vue&type=script&lang=js&"
export * from "./OnboardingWizard3Page.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingWizard3Page.vue?vue&type=style&index=0&id=4c880435&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c880435",
  null
  
)

export default component.exports